<template>
    <div class="settings-panel">
        <div class="settings-panel__inner">
            <div v-if="isShowNotification" :class="namespaceClass('notification')">
                <div class="mds-notification">
                    <div role="alertdialog" class="mds-notification__item mds-notification__item--success mds-notification__item--dismissible">
                        <div class="mds-notification__status">
                            <svg class="mds-icon mds-notification__icon">
                                <use xlink:href="#check"><title>Success</title></use>
                            </svg>
                        </div>
                        <div class="mds-notification__body">
                            <div class="mds-notification__content">
                                <p class="mds-notification__message">
                                    {{ getUILabel("portfolio_transactions_removed_text") }}
                                </p>
                                <button class="mds-button mds-button--small mds-button--secondary" type="button" @click="handleUndo">
                                    {{ getUILabel("common_undo") }}
                                </button>
                            </div>
                        </div>
                        <button
                            class="mds-button mds-notification__dismiss-button mds-button--small mds-button--icon-only"
                            type="button"
                            @click="isShowNotification = false"
                        >
                            <svg class="mds-icon mds-button__icon mds-button__icon--right">
                                <use xlink:href="#remove--s"><title>Close</title></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <mds-section
                e2e="transactions-section"
                :size="7"
                :collapsible="includeContributionAndWithdrawal"
                bold
                ref="section"
                border="secondary"
                @mds-section-expanded="expandSection"
                @mds-section-closed="closeSection"
            >
                <template v-slot:mds-section-title>
                    <span :class="{ 'contributions-and-withdrawals--disabled': !includeContributionAndWithdrawal }">{{ getUILabel(text) }}</span>
                </template>
                <template v-slot:mds-section-actions>
                    <mds-switch e2e="transactions-switch" v-model="includeContributionAndWithdrawal" @change="toggleInclude">{{
                        getUILabel("common_include")
                    }}</mds-switch>
                </template>
                <template v-slot:default>
                    <div v-if="includeContributionAndWithdrawal">
                        <transactions-content :mwcId="getMwcIdForChild('content')" ref="content" @changeNotificationStatus="e => (isShowNotification = e)">
                        </transactions-content>
                    </div>
                </template>
            </mds-section>
            <transactions-summary v-if="!expanded && includeContributionAndWithdrawal" :mwcId="getMwcIdForChild('summary')"></transactions-summary>
        </div>
    </div>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import TransactionsContent from "./Transaction.vue";
import TransactionsSummary from "./Summary";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import MdsSection from "@mds/section";
import MdsSwitch from "@mds/switch";
import * as types from "../store/mutation-types";

export default {
    name: "transactions-panel",
    props: {
        text: String
    },
    components: {
        MdsSection,
        MdsSwitch,
        TransactionsContent,
        TransactionsSummary
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            isShowNotification: false,
            expanded: false
        };
    },
    computed: {
        includeContributionAndWithdrawal: {
            get() {
                return this.$store.state.transaction.includeContributionAndWithdrawal;
            },
            set(value) {
                this.$store.commit(`transaction/${types.SET_INCLUDE_CONTRIBUTION_AND_WITHDRAWAL}`, value);
            }
        }
    },
    methods: {
        toggleInclude(value, event) {
            this.$refs.section.toggle(event);
        },
        expandSection() {
            this.expanded = true;
        },
        closeSection() {
            this.expanded = false;
        },
        handleUndo() {
            if (this.expanded) {
                if (this.$refs.content && this.$refs.content.$refs.portfolioTransaction) {
                    this.$refs.content.$refs.portfolioTransaction.handleUndo();
                }
            } else {
                this.isShowNotification = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.contributions-and-withdrawals--disabled {
    color: #9b9b9b;
}
.transactions-panel {
    &-notification {
        .mds-notification {
            position: fixed;
            display: block;
            top: $mds-space-2-x;
            left: 50%;
            transform: translateX(-50%);

            .mds-notification__item {
                display: flex;
            }
        }
    }
}
</style>
